import axios from 'axios';
import config from '../config';

export const createPayment = (entity) => axios.post(config.REACT_APP_API_URL + '/payment', entity, {
    headers: {
        'Content-Type': 'application/json',
    }
})

// Mirrors createPayment's direct-axios convention since /Payment/* is a top-level route, not under /api.
export const createPaymentIntent = (entity) => axios.post(config.REACT_APP_API_URL + '/payment/stripe/createintent', entity, {
    headers: {
        'Content-Type': 'application/json',
    }
})
